import { Form } from "react-bootstrap";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface OptionsItem {
  label: React.ReactNode;
  value: string;
  hidden?: boolean;
  disabled?: boolean;
}
interface ISelectFieldProps {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  errors?: FieldErrors<any>;
  required?: boolean;
  defaultValue?: string;
  options: OptionsItem[];
  disabled?: boolean;
  addClassName?: string;
  getLabel?: (key: string) => string; // i18n 함수
}
const SelectField = ({
  name,
  label,
  register,
  errors,
  required = false,
  options,
  disabled,
  addClassName = "",
}: // handleChange,
ISelectFieldProps) => {
  const error = errors?.[name];
  return (
    <div className="form-item">
      <label className="form-item-title">
        {label}
        {required && (
          <span className={`text text--${error ? "red" : "green"}`}>
            &nbsp;*
          </span>
        )}
      </label>
      <Form.Select
        // name={name}
        disabled={disabled}
        className={`form-control custom-form width w-370 ${addClassName}`}
        {...register(name)}
      >
        {options
          .filter((opt) => !opt.hidden)
          .map((opt) => (
            <option key={opt.value} value={opt.value} disabled={opt.disabled}>
              {opt.label}
            </option>
          ))}
      </Form.Select>
    </div>
  );
};
export default SelectField;
